import React, { Component } from 'react';
import update from 'react-addons-update';
import quizQuestions from './data/quizQuestions';
import Quiz from './components/Quiz';
import Result from './components/Result';
import concordlogo from './svg/concordlogo.png';
import './App.css';
var uuid = require('uuid');

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id:uuid.v1(),
      name: '',
      email: '',
      consent: true,
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      answer: '',
      answersCount: {
        Administration: 0,
        Apostleship: 0,
        'Artistic Expression': 0,
        Craftsmanship: 0,
        Discernment: 0,
        Evangelism: 0,
        Exhortation: 0,
        Faith: 0,
        Giving: 0,
        Helps: 0,
        Hospitality: 0,
        Intercession: 0,
        Knowledge: 0,
        Leadership: 0,
        Mercy: 0,
        Prophecy: 0,
        Shepherding: 0,
        Teaching: 0,
        Wisdom: 0
      },
      results: []
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    const shuffledAnswerOptions = quizQuestions.map((question) => this.shuffleArray(question.answers));
    this.setState({
      question: quizQuestions[0].question,
      answerOptions: shuffledAnswerOptions[0]
    });
  }

  shuffleArray(array) {
    //TODO: get rid of this shuffling
    return array;
  };

  handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value);

    if (this.state.questionId < quizQuestions.length) {
    //if (this.state.questionId < 3) {
        setTimeout(() => this.setNextQuestion(), 300);
    } else {
        setTimeout(() => this.setResults(this.getResults()), 300);
    }
  }

  handleSubmit(event) {
    this.setState({
        name: this.refs.name.value,
        email: this.refs.email.value
    });
    event.preventDefault();
  }

  setUserAnswer(answer) {
    const answerParts = answer.split('|');
    const type = answerParts[0];
    const value = Number(answerParts[1]);
    const updatedAnswersCount = update(this.state.answersCount, {
      [type]: {$apply: (currentValue) => currentValue + value}
    });

    this.setState({
        answersCount: updatedAnswersCount,
        answer: answer
    });
  }

  setNextQuestion() {
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;

    this.setState({
        counter: counter,
        questionId: questionId,
        question: quizQuestions[counter].question,
        answerOptions: quizQuestions[counter].answers,
        answer: ''
    });
  }

  getResults() {
    const answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);
    answersCountKeys.sort(function(a, b) { return answersCount[b] - answersCount[a] });
    const sortedResults = answersCountKeys.map(gift => gift + ": " + answersCount[gift]);
    return sortedResults;

  }

  setResults(results) {
    this.setState({ results: results });

    fetch('/api/survey', {
      method: 'post',
      headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
        consent: this.state.consent,
        results: this.state.results
      })
  });
  }

  renderLogin() {
    return (
      <div className="welcome-page">
        <p>Welcome to the Concord Church Spiritual Gifts Assessment! God has uniquely designed
           each of us to do work to support and build the Kingdom of God. 
           We hope it will be helpful as you seek to discover more about how God has uniquely 
           designed you.</p>
        <p>The assessment is simple and easy to follow. Once you answer a question, the next 
          question will automatically be displayed. You will not be given the opportunity to change 
          your answers because we do not want you to overthink your answers. We want you to go 
          with what comes to mind first. Please keep in mind this assessment will take 10-15 
          minutes to complete.</p>
        <p>Once you complete the assessment, your consent below allows Concord Church to store 
          your results in a confidential database accessible only to church staff and ministry 
          leaders. This database is used to help people connect to the ministry opportunities 
          that are most compatible with their gifts.</p>
        <p>Providing your email below allows us to send you an email containing your results 
          from grow@concorddallas.org. If you do not see an email within a couple of hours, 
          please check your spam or junk folder. We value your privacy and will never sell your 
          email address or share it outside the church community.</p>
        <p>It’s time to take your Next Step! Let’s Go!</p>
        <form onSubmit={this.handleSubmit}>
          <input type="text" placeholder="Enter your name (Required)" ref="name" />
          <br /><br />
          <input type="text" placeholder="Enter your email address (Required)" ref="email" />
          <br /><br />
          <fieldset>
            <input type="checkbox" id="consent" name="consentCheck" ref="consent" checked />
            <label>I am affiliated with Concord Church, and I give consent for my spiritual 
              gifts assessment results to be added to the church database.
            </label>
          </fieldset>
          <br />
          <input type="submit" value="Submit" />
          <br /><br />
        </form>
      </div>
    );
  }

  renderQuiz() {
    return (
      <Quiz
        answer={this.state.answer}
        answerOptions={this.state.answerOptions}
        questionId={this.state.questionId}
        question={this.state.question}
        questionTotal={quizQuestions.length}
        onAnswerSelected={this.handleAnswerSelected}
      />
    );
  }

  renderResult() {
    return (
      <Result quizResult={this.state.results} />
    );
  }

  renderPage() {
    if (this.state.name.length < 1) {
      return this.renderLogin();
    } else if (this.state.results.length > 0) {
      return this.renderResult();
    } else {
      return this.renderQuiz();
    }
  }

  render() {
    var content = this.renderPage();
    return (
      <div className="App">
        <div className="App-header">
          <img src={concordlogo} alt="logo" />
          <h2>Spiritual Gifts Assessment</h2>
        </div>
        {content}
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js